import Vue from "vue";
import Vuex, { Store } from "vuex";

Vue.use(Vuex);

export interface Role {
    id: number;
    name: string;
}

export interface User {
    id: number;
    name: string;
    roles: Role[];
}

export interface Manufacturer {
    id: string;
    name: string;
    hasLogo: boolean;
    logoUrl: string;
    faviconUrl: string;
    slug: string;
    hasFavicon: boolean;
    customFooter: string;
}

export interface Shipper {
    name: string;
    trackingOrderUrl: string;
    trackingNumber: string;
}

export interface TrackingOrder {
    id: string;
    manufacturer: Manufacturer;
    purchaseOrderNumber: string;
    trackingOrderLines: TrackingOrderLine[];
    shipments: Shipper[];
}

export interface TrackingOrderLine {
    description: string;
    estimatedShipDate: string;
    id: string;
    lineNumber: number;
    orderDate: string;
    partNumber: string;
    quantity: number;
}

export type State = {
    user: User | null;
    version: string | null;
};

export interface StoreInterface extends Store<State> {}

type About = {
    version: string;
};

const vue = new Vue();
export default new Store<State>({
    state: {
        user: null,
        version: null,
    },
    getters: {
        version: state => {
            return state.version;
        },
    },
    mutations: {
        clearUser(context) {
            context.user = null;
        },
        setUser(context, user: User) {
            context.user = user;
        },
        setVersion(context, about: About) {
            context.version = about.version;
        },
    },
    actions: {
        async login(context, token: string) {
            const response = await vue.$http.get<User>("/api/v0/users/me");
            context.commit("setUser", response.data);
        },
        async logout(context) {
            await vue.$http.post("/api/v0/authentication/logout");
            context.commit("clearUser");
        },
        async load(context) {
            const response = await vue.$http.get<About>("/api/v0/about");
            context.commit("setVersion", response.data);
        },
    },
    modules: {},
});
